import { render, staticRenderFns } from "./DeliveryForm.vue?vue&type=template&id=4225ca9f&scoped=true&"
import script from "./DeliveryForm.vue?vue&type=script&lang=js&"
export * from "./DeliveryForm.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryForm.vue?vue&type=style&index=0&id=4225ca9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4225ca9f",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/delivery_form.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fbasket%2FDeliveryForm.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports